/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */


Monet.Builder = Monet.Builder || {};
Monet.Builder.Form = Monet.Builder.Form || {};
Monet.Builder.Form.Base = Monet.Builder.Form.Base || {};

Monet.Builder.Form.Base = (function (){

    /**
     * FormBuilder constructor
     * @param {object} pageLayout
     * @param {object} entity
     * @constructor
     */
   function FormBuilder (pageLayout, entity) {

        this.fields = {};
        this.buttons = {};
        this.model = null;
        this.fragment =  document.createDocumentFragment();
        this.crudStage = "";
        this.rootEl = null;

        this.setModel = (model) => {
            this.model = model;
            return this;
        };

        this.getModel = () => {
            return this.model;
        };

        this.setOptions = (options) => {
            this.options = options;
        };

        this.setCrudStage = (crudStage) => {
            this.crudStage = crudStage;

            if(this.rootEl) {
                this.rootEl.setAttribute('crudStage', this.crudStage);
            }
        };

        this.extractInfoFromSections = (info) => {
            let infoList = [];

            if(pageLayout){
                const sections = this.getSections();
                sections.forEach(section => {
                    var data = section[info];
                    if(data && data.length){
                        infoList.push(data);
                    }
                })

            }

            return infoList;
        };

        this.getSections = () => pageLayout ? pageLayout.sections : [];
        this.getRelatedLists = () => this.extractInfoFromSections('sectionRelatedLists');
        this.getSectionButtons = () => this.extractInfoFromSections('sectionButtons');
        this.getSectionFields = () => this.extractInfoFromSections('sectionFields');

        this.parseSectionButton = (sectionButton) => {

            return {
                 label: sectionButton.customLabel
                ,type: 'BUTTON'
                ,customJavaScript: sectionButton.customJavaScript
                ,name: sectionButton.name
            };
        };

        this.createContainer = (className, innerHTML) => {
            const container = document.createElement('div');
            container.className = className;
            if (innerHTML) {
                container.innerHTML = innerHTML;
            }
            return container;
        };

        this.getValues = () => {
            const values = {};

            for(let key in this.fields){
                if(this.fields.hasOwnProperty(key)){
                    const field = this.fields[key];
                    const value = field.getValue();

                    if(value !== null && typeof value !== 'undefined' && value !== ''){
                        values[key] = value;
                    }
                }
            }

            return values;
        };

        this.getAllButtons = () => {
            const allButtons = [];
            for (let key in this.buttons) {
                this.buttons[key].forEach(button => allButtons.push(button));
            }
            return allButtons;
        };

        this.validate = () => {
            let errors = [],
                field,
                value;

            const results = {
                status: true,
                errorMessages: []
            };

            for (var key in this.fields) {
                if (this.fields.hasOwnProperty(key)) {
                    field = this.fields[key];

                    field.rootEl.className = field.rootEl.className.replace('control-group error', '') ;
                    value = field.getValue();
                    // ou faz a validação aqui 
                    //testar AQUI se existe / na string se nao tiver Jogar o Erro
                    const fieldErrors = field.validate();
                    if(fieldErrors && fieldErrors.length > 0){
                        errors = errors.concat(fieldErrors);
                    }
                }
            }

            if (errors.length > 0) {
                results.status = false;
                results.errorMessages = results.errorMessages.concat(errors);
            }

            return results;
        };


        this.disableFields = () => {

            for (var key in this.fields){
                const monetField = this.fields[key];
                if(this.fields.hasOwnProperty(key) && monetField.field && monetField.field.readOnly) {

                    monetField.disable();
                }
            }

            return this;
        };

        this.clearAllFields = () => {
            for (var field in this.fields){
                if(field !== 'id' && this.fields.hasOwnProperty(field)){
                    this.fields[field].clear();
                }
            }
        };

        /*
           Metodo usado no edit dos forms, pois eh necessario enviar o id da entidade a ser editada.
         */
        this.setEntityId = (id) => {
            this.setFakeField('id', id);
        };

        this.setFakeField = (name, value) => {
            var fieldId = new Monet.UI.Fields.Base();
            fieldId.setValue(value);
            fieldId.field = { type:'TEXT' };
            fieldId.render();
            this.setField(name, fieldId);
        };

        this.getJSONFields = () => {
            var jsonObject = {};
            for (var field in this.fields){

                if(this.fields.hasOwnProperty(field)){

                    var value  = this.fields[field].getValue();
                    if(value){
                        jsonObject[field] = value;
                    }

                }
            }
            return JSON.stringify(jsonObject);
        };

        this.setFieldsValues = (fields) => {
            for( var key in fields){
                this.setFieldValue(key, fields[key]);
            }
        };

        this.setFieldValue = (fieldId, value) => {
            var field = this.fields[fieldId];
            if(field){
                field.setValue(value);
            }
        };

        this.getFields = () => this.fields;

        this.getField = (fieldId) => this.fields[fieldId];

        this.setField = (fieldId, field) => this.fields[fieldId] = field;


        var _getSectionColumnQuant = (sectionFields) => {

            sectionFields = sectionFields.sort(function(a, b) {
                return a.sectionColumn - b.sectionColumn;
            });

            return sectionFields[sectionFields.length - 1].sectionColumn;

        };

        this.getTopBottomButtons = () => {
            return pageLayout.sections[0].sectionButtons;
        };

        this.renderSectionButtons = ({ sectionButtons, className } = {})  => {

            if (pageLayout) {
                const div =  this.createContainer('MonetUIFormSectionButton');
                className && div.classList.add(className);

                
                if (sectionButtons) {
                    const sortedButtons = sectionButtons.slice().sort(function(a, b){
                        return a.buttonOrder - b.buttonOrder;
                    });
                    
                    sortedButtons.forEach((button) => {
                        const item = this.parseSectionButton(button);
                        const fieldRender = new Monet.UI.Fields.Render(item, entity);
                        const buttonField = fieldRender.render(item);
                        const renderedButton = buttonField.rootEl;
                        renderedButton.setAttribute('name', button.name);
                        renderedButton.setAttribute('buttonOrder', button.buttonOrder);
                        renderedButton.className='MonetUIButton btn';
                        div.appendChild(renderedButton);

                        if (!this.buttons[button.name]) {
                            this.buttons[button.name] = [];
                        }

                        this.buttons[button.name].push(buttonField);
                    });
                }

                return div;
            }

        };

        this.triggerLoadingBtns = () => {
            const buttons = this.buttons;
            for (var property in buttons){
                const flagNewAndCancel = property.includes('new') && property.includes('cancel');

                if((property.includes('save') 
                || property.includes('new')
                || property.includes('novo')
                || property.includes('filtrar')
                || property.includes('delete'))
                && !flagNewAndCancel) {
                    buttons[property].map(btn => btn.toggleLoadingInBtn());
                } else {
                    buttons[property].map(btn => btn.toggleDisabled());
                }
            }
        };

        this.renderSectionColumns = (parent, sectionFields) => {

            var _sectionFields = sectionFields;

            if(_sectionFields && _sectionFields.length > 0){

                var maxColumn = _getSectionColumnQuant(_sectionFields),
                    sectionFieldsLength = _sectionFields.length;

                for (var i = 1; i <= maxColumn; i++) {

                    var columnDiv = document.createElement('div');
                    columnDiv.className = 'MonetUIFormSectionColumn';
                    columnDiv.setAttribute('sectionColumn', i);

                    var fieldToColumn = [];

                    for (var j = 0; j < sectionFieldsLength; j++) {
                        var sf = _sectionFields[j];

                        if (sf.sectionColumn === i) {
                            fieldToColumn.push(sf);
                        }
                    }
                    this.renderSectionFields(columnDiv, fieldToColumn);
                    parent.appendChild(columnDiv);
                }
            }

        };

        this.modifyRequiredLabels = (field) => {
            
            const labels = {
                'pro.optimizationObjectives': 'pro.optimizationObjectives.withTip',
            };

            if (labels[field.label]) {
                return labels[field.label]
            } else {
                return field.label;
            }

        };

        this.renderSectionFields = (parent, sectionFields) => {

            var fieldRender = null,
                rendered = null,
                length = sectionFields.length;

            sectionFields = sectionFields.sort(function(a, b){
                return a.sectionOrder - b.sectionOrder;
            });

            for (var j = 0; j < length; j++) {

                var field = sectionFields[j].field;

                if (!this.options) {
                    this.options = {};
                }
                this.options.behaveAs =  sectionFields[j].behaveAs;

                fieldRender = new Monet.UI.Fields.Render(field, entity, this.options);

                field.label = this.modifyRequiredLabels(field);

                rendered = fieldRender.render(field);
                rendered.rootEl.setAttribute("sectionOrder",sectionFields[j].sectionOrder);

                this.fields[field.name] = rendered;
                this.fields[field.name].field = field;

                parent.appendChild(rendered.rootEl);
            }
        };

        this.renderGridHeader = () => {
            const container = this.createContainer('gridHeaderContainer');
            const leftContainer = this.createContainer('leftContainer');
            const buttons = this.renderSectionButtons({ sectionButtons: this.getTopBottomButtons(), className: 'buttonsUp' });

            container.appendChild(leftContainer);
            container.appendChild(buttons);

            return container;
        };

        this.renderBaseForm = () => {

            const isGrid = pageLayout && pageLayout.userInterfaceAction && pageLayout.userInterfaceAction.key === 'index';
            const allContent = document.createElement('form');
            const errorContainer = this.createContainer('monetInlineAlerContainer');
            let lists;

            this.rootEl = allContent;

            allContent.className = 'MonetUIForm '+ entity;
            allContent.setAttribute('crudStage', this.crudStage);
            allContent.setAttribute('autocomplete', "off");
            
            // This is necessary so the datepicker can follow scroll properly even if inside a lookup filter container.
            // Please remove this once this datepicker plugin is annihilated or if you find a better solution.
            let previousScrollPos = allContent.scrollTop;
            allContent.addEventListener('scroll', () => {
                const dp = document.querySelector('#ui-datepicker-div');
                if ($.datepicker._datepickerShowing) {
                    const diff = previousScrollPos - allContent.scrollTop;
                    dp.style.top = (parseInt(dp.style.top.split('px')[0]) + diff) + 'px';
                }
                previousScrollPos = allContent.scrollTop;
            });

            allContent.appendChild(errorContainer);

            if (isGrid) {
                allContent.appendChild(this.renderGridHeader());
            }

            const sections = this.getSections();
            sections.forEach((section, index) => {
                const sectionDiv = this.createContainer('MonetUIFormSection');
                sectionDiv.setAttribute('key', section.key);
                allContent.appendChild(sectionDiv);

                if (!isGrid) {
                    if ((section.sectionButtons && section.sectionButtons.length) || index === 0) {
                        const sectionButtons = section.sectionButtons || (index === 0 && this.getTopBottomButtons());
                        const className = index === 0 ? 'buttonsUp' : '';
                        const buttons = this.renderSectionButtons({ sectionButtons, className });
                        sectionDiv.appendChild(buttons);
                    }

                    if (this.renderAndAppendTitle) {
                        this.renderAndAppendTitle(sectionDiv, section);
                    }
                }

                if (section.sectionFields && section.sectionFields.length) {
                    const sectionFields = this.createContainer('MonetUIFormSectionFields');
                    this.renderSectionColumns (sectionFields, section.sectionFields);
                    sectionDiv.appendChild(sectionFields);
                }

                if (section.sectionRelatedLists && section.sectionRelatedLists.length) {
                    lists = true;
                    sectionDiv.appendChild(this.renderRelatedList(section.sectionRelatedLists));
                }
            });

            const sectionDownButton = sections[0];
            if (sectionDownButton && sectionDownButton.sectionButtons && !lists) {
                const { sectionButtons } = sectionDownButton;
                const buttonsFooter = this.renderSectionButtons({ sectionButtons, className: 'buttonsDown' });
                const sectionDivDownButtons = this.createContainer('MonetUIFormSection');
                sectionDivDownButtons.setAttribute('key', sectionDownButton.key);
                sectionDivDownButtons.appendChild(buttonsFooter);
                allContent.appendChild(sectionDivDownButtons);
            }

            return { allContent, sections, lists };
        };

        this.populateFields = () => {

            this.setFieldsValues(this.model.attributes);
            this.setEntityId(this.model.attributes.id);
            return this;
        };

        /**
         * Fires the postRender hook of every form field.
         * @public
         */
        this.postRender = () => {
            for (var field in this.fields) {
                field = this.fields[field];
                if (!!field.postRender) {
                    field.postRender();
                }
            }
        };
   }

   return FormBuilder;

}());
